<template>
    <div class="row g-3">
        <!-- Left: File Table -->
        <div class="col-lg-8">
            <div class="d-flex align-items-center justify-content-between mb-3">
                <div class="d-flex align-items-center gap-2">
                    <span class="file-header-icon">
                        <i class="bi bi-folder2-open"></i>
                    </span>
                    <h6 class="mb-0 fw-bold">Əlavə edilmiş fayllar</h6>
                </div>
                <span class="badge bg-secondary-subtle text-secondary fw-bold">{{ tableData.length }} fayl</span>
            </div>

            <div class="table-responsive">
                <el-table border stripe class="el-table-css" :data="tableData" style="width: 100%;">
                    <!-- Download Action -->
                    <el-table-column width="54" align="center">
                        <template #default="scope">
                            <button type="button" class="btn table-icon-btn text-primary" @click="download(scope.row.title)" title="Yüklə">
                                <i class="bi bi-download"></i>
                            </button>
                        </template>
                    </el-table-column>

                    <!-- Date -->
                    <el-table-column label="Tarix" prop="createdDateStr" width="120" align="center">
                        <template #default="scope">
                            <span class="task-time-chip font-monospace">{{ scope.row.createdDateStr }}</span>
                        </template>
                    </el-table-column>

                    <!-- File Name & Icon -->
                    <el-table-column label="Faylın adı" min-width="220">
                        <template #default="scope">
                            <div class="d-flex align-items-center gap-2">
                                <span class="file-ext-icon" :class="'ext-' + scope.row.ext.replace('.', '')">
                                    <i :class="getFileIcon(scope.row.ext)"></i>
                                </span>
                                <a @click="download(scope.row.title)" class="file-name-link fw-semibold">
                                    {{ scope.row.title }}
                                </a>
                            </div>
                        </template>
                    </el-table-column>

                    <!-- Delete Action -->
                    <el-table-column width="54" align="center">
                        <template #default="scope">
                            <button type="button" class="btn table-icon-btn text-danger" @click="deleteFile(scope.$index)" title="Sil">
                                <i class="bi bi-trash3"></i>
                            </button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!-- Right: Modern Upload Box -->
        <div class="col-lg-4">
            <div class="modern-upload-card p-3 rounded text-center">
                <el-upload class="upload-area" drag action="#" :auto-upload="false" multiple>
                    <div class="upload-icon-wrapper mb-2">
                        <i class="bi bi-cloud-arrow-up-fill text-primary" style="font-size: 2.2rem;"></i>
                    </div>
                    <div class="el-upload__text">
                        <span class="fw-bold d-block text-dark-emphasis mb-1">Faylı bura sürükləyin</span>
                        <small class="text-muted">və ya kompüterdən seçmək üçün <em>klikləyin</em></small>
                    </div>
                    <template #tip>
                        <div class="el-upload__tip mt-2 text-muted" style="font-size: 0.76rem;">
                            PDF, DOCX, XLSX, PNG formatları dəstəklənir (maks. 25 MB)
                        </div>
                    </template>
                </el-upload>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ContractFiles",
    data() {
        return {
            tableData: [
                {
                    createdDateStr: "21.08.2025",
                    title: "Hesabat_2025.xlsx",
                    ext: ".xlsx",
                    commandUserId: 1
                },
                {
                    createdDateStr: "19.08.2025",
                    title: "Müqavilə.docx",
                    ext: ".docx",
                    commandUserId: 2
                },
                {
                    createdDateStr: "15.08.2025",
                    title: "Şərtlər.pdf",
                    ext: ".pdf",
                    commandUserId: 1
                },
                {
                    createdDateStr: "10.08.2025",
                    title: "Foto.png",
                    ext: ".png",
                    commandUserId: 3
                }
            ]
        };
    },
    methods: {
        download(title) {
            console.log("Downloading", title);
        },
        deleteFile(index) {
            this.tableData.splice(index, 1);
        },
        getFileIcon(ext) {
            if (ext === ".xlsx" || ext === ".xls") return "bi bi-file-earmark-excel-fill text-success";
            if (ext === ".docx" || ext === ".doc") return "bi bi-file-earmark-word-fill text-primary";
            if (ext === ".pdf") return "bi bi-file-earmark-pdf-fill text-danger";
            return "bi bi-file-earmark-image-fill text-warning";
        }
    }
};
</script>

<style scoped lang="scss">
.file-header-icon {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    background: rgba(11, 79, 156, 0.1);
    color: var(--bs-info, #0b4f9c);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
}

.table-icon-btn {
    width: 28px;
    height: 28px;
    padding: 0 !important;
    margin: 0 !important;
    border-radius: 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: transparent;
    transition: all 0.15s ease;

    &:hover {
        background: rgba(0, 0, 0, 0.06);
    }
}

.file-ext-icon {
    font-size: 1.2rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.file-name-link {
    color: var(--bs-info, #0b4f9c);
    cursor: pointer;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}

.task-time-chip {
    font-size: 0.78rem;
    font-weight: 650;
    padding: 2px 6px;
    border-radius: 4px;
    background: var(--app-surface-soft, #f8fafc);
    border: 1px solid var(--app-border, #e2e8f0);
}

.modern-upload-card {
    background: var(--app-surface-soft, #f8fafc);
    border: 1px solid var(--app-border, #e2e8f0);
}

:deep(.upload-area) {
    .el-upload-dragger {
        background: var(--app-surface, #ffffff);
        border: 2px dashed var(--app-border-strong, #cbd5e1);
        border-radius: 8px;
        padding: 24px 16px;
        transition: all 0.2s ease;

        &:hover {
            border-color: var(--bs-info, #0b4f9c);
            background: rgba(11, 79, 156, 0.02);
        }
    }
}

[data-theme="dark"] {
    .file-header-icon {
        background: rgba(59, 130, 246, 0.2);
        color: #60a5fa;
    }

    .table-icon-btn:hover {
        background: rgba(255, 255, 255, 0.1);
    }

    .file-name-link {
        color: #93c5fd;
    }

    .task-time-chip {
        background: #141b22;
        border-color: #283544;
        color: #e2e8f0;
    }

    .modern-upload-card {
        background: #141b22;
        border-color: #283544;
    }

    :deep(.upload-area) {
        .el-upload-dragger {
            background: #182029;
            border-color: #3b4758;

            &:hover {
                border-color: #60a5fa;
                background: rgba(59, 130, 246, 0.05);
            }
        }
    }
}
</style>